module.exports = __webpack_public_path__ + "static/media/alert-circle.9807d5fa.svg";